export enum UploaderView {
  modal = 'modal',
  dragDrop = 'dragDrop',
}
